import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import api from '../services/api';

export default function SignTypes() {
  const [signTypes, setSignTypes] = useState([]);
  const [typeForm, setTypeForm] = useState({ key: '', label: '', default_message_fr: '' });
  const [typeImage, setTypeImage] = useState(null);
  const [editingType, setEditingType] = useState(null);
  const typeFileRef = useRef(null);

  useEffect(() => { loadSignTypes(); }, []);

  const loadSignTypes = () => {
    api.get('/sign-types/').then((r) => setSignTypes(r.data.results || r.data)).catch(() => {});
  };

  const handleSaveType = () => {
    const fd = new FormData();
    fd.append('key', typeForm.key);
    fd.append('label', typeForm.label);
    fd.append('default_message_fr', typeForm.default_message_fr || '');
    if (typeImage) fd.append('image', typeImage);

    const req = editingType
      ? api.patch(`/sign-types/${editingType}/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      : api.post('/sign-types/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });

    req.then(() => {
      loadSignTypes();
      setTypeForm({ key: '', label: '', default_message_fr: '' });
      setTypeImage(null);
      setEditingType(null);
      if (typeFileRef.current) typeFileRef.current.value = '';
    }).catch(() => {});
  };

  const handleEditType = (t) => {
    setEditingType(t.id);
    setTypeForm({ key: t.key, label: t.label, default_message_fr: t.default_message_fr || '' });
    setTypeImage(null);
  };

  const handleDeleteType = (id) => {
    api.delete(`/sign-types/${id}/`).then(() => loadSignTypes()).catch(() => {});
  };

  const handleToggleActive = (t) => {
    api.patch(`/sign-types/${t.id}/`, { active: !t.active }).then(() => loadSignTypes()).catch(() => {});
  };

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h4 style={{ color: '#fff', marginBottom: 20 }}>
        <i className="bi bi-collection" style={{ color: '#2979ff', marginRight: 8 }}></i>
        Types de signalisation
        <span style={{ fontSize: 14, color: '#888', marginLeft: 12 }}>{signTypes.length} types</span>
      </h4>

      {/* Create / Edit form */}
      <div style={{ background: '#111128', borderRadius: 12, padding: 20, marginBottom: 24, border: '1px solid #222' }}>
        <h6 style={{ color: '#2979ff', marginBottom: 12 }}>
          <i className={`bi ${editingType ? 'bi-pencil' : 'bi-plus-circle'}`}></i>{' '}
          {editingType ? 'Modifier le type' : 'Nouveau type'}
        </h6>
        <div className="d-flex gap-3 mb-3">
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="text-muted" style={{ fontSize: 11 }}>Clé technique</Form.Label>
            <Form.Control size="sm" placeholder="ex: stop, speed_limit"
              value={typeForm.key} onChange={(e) => setTypeForm({ ...typeForm, key: e.target.value })}
              disabled={!!editingType}
              style={{ background: '#0d0d1a', border: '1px solid #333', color: '#fff' }} />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="text-muted" style={{ fontSize: 11 }}>Libellé</Form.Label>
            <Form.Control size="sm" placeholder="ex: Stop, Limitation de vitesse"
              value={typeForm.label} onChange={(e) => setTypeForm({ ...typeForm, label: e.target.value })}
              style={{ background: '#0d0d1a', border: '1px solid #333', color: '#fff' }} />
          </Form.Group>
        </div>
        <Form.Group className="mb-3">
          <Form.Label className="text-muted" style={{ fontSize: 11 }}>Message vocal par défaut</Form.Label>
          <Form.Control size="sm" placeholder="Attention, ..."
            value={typeForm.default_message_fr} onChange={(e) => setTypeForm({ ...typeForm, default_message_fr: e.target.value })}
            style={{ background: '#0d0d1a', border: '1px solid #333', color: '#fff' }} />
        </Form.Group>
        <div className="d-flex align-items-center gap-3">
          <label className="btn btn-sm" style={{ background: 'rgba(41,121,255,0.15)', color: '#2979ff', cursor: 'pointer', borderRadius: 8, padding: '6px 14px' }}>
            <i className="bi bi-image"></i> {typeImage ? typeImage.name.substring(0, 20) : 'Choisir une image'}
            <input type="file" accept="image/*" ref={typeFileRef} hidden
              onChange={(e) => setTypeImage(e.target.files[0] || null)} />
          </label>
          <button className="btn btn-sm ms-auto" onClick={handleSaveType}
            disabled={!typeForm.key || !typeForm.label}
            style={{ background: '#2979ff', color: '#fff', borderRadius: 8, padding: '6px 20px', fontWeight: 600 }}>
            <i className={`bi ${editingType ? 'bi-check-lg' : 'bi-plus'}`}></i>{' '}
            {editingType ? 'Enregistrer' : 'Créer'}
          </button>
          {editingType && (
            <button className="btn btn-sm" onClick={() => { setEditingType(null); setTypeForm({ key: '', label: '', default_message_fr: '' }); setTypeImage(null); }}
              style={{ background: 'rgba(255,255,255,0.08)', color: '#888', borderRadius: 8, padding: '6px 14px' }}>
              Annuler
            </button>
          )}
        </div>
      </div>

      {/* Types list */}
      <div style={{ background: '#111128', borderRadius: 12, border: '1px solid #222' }}>
        {signTypes.length === 0 ? (
          <p style={{ color: '#888', textAlign: 'center', padding: 40 }}>
            Aucun type créé. Utilisez le formulaire ci-dessus pour ajouter des types de signalisation.
          </p>
        ) : (
          signTypes.map((t) => (
            <div key={t.id} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: '12px 20px',
              borderBottom: '1px solid #1a1a3e',
            }}>
              {t.image ? (
                <img src={t.image} alt="" style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover', border: '2px solid #333' }} />
              ) : (
                <div style={{ width: 48, height: 48, borderRadius: 8, background: 'rgba(41,121,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="bi bi-signpost-split" style={{ color: '#2979ff', fontSize: 20 }}></i>
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: t.active ? '#fff' : '#666' }}>{t.label}</div>
                <div style={{ fontSize: 11, color: '#888', fontFamily: 'monospace' }}>{t.key}</div>
                {t.default_message_fr && (
                  <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                    <i className="bi bi-volume-up" style={{ marginRight: 4 }}></i>{t.default_message_fr}
                  </div>
                )}
              </div>
              <Form.Check type="switch" checked={t.active !== false} onChange={() => handleToggleActive(t)}
                style={{ marginRight: 8 }} />
              <button className="btn btn-sm" onClick={() => handleEditType(t)}
                style={{ color: '#2979ff', background: 'none', border: 'none' }}>
                <i className="bi bi-pencil"></i>
              </button>
              <button className="btn btn-sm" onClick={() => handleDeleteType(t.id)}
                style={{ color: '#ff1744', background: 'none', border: 'none' }}>
                <i className="bi bi-trash"></i>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
